let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7H46t")).then(() => parcelRequire('cEOMi'));